import { Routes, Route } from "react-router-dom";
import MainLayout from "../layouts/MainLayout";
import GISWorkspace from "../pages/GISWorkspace/GISWorkspace";
import Dashboard from "../pages/Dashboard/Dashboard";
import DrilldownDashboard from "../pages/Dashboard/DrilldownDashboard";
import Schemes from "../pages/Schemes/Schemes";
import SchemeForm from "../pages/Schemes/SchemeForm/SchemeForm";
import SchemeDetail from "../pages/Schemes/SchemeForm/SchemeDetail"; // ← New import
import Users from "../pages/Users/Users";
import ProtectedRoute from "../utils/ProtectedRoute"; // ← New import 

function AppRoutes() {
  return (
    
    <Routes>
      <Route element={<MainLayout />}>
        <Route element={<ProtectedRoute />}>
          <Route path="/" element={<GISWorkspace />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/analytics/drilldown/:id" element={<DrilldownDashboard />} />
          <Route path="/schemes" element={<Schemes />} />
          <Route path="/schemes/:id" element={<SchemeDetail />} />
          <Route path="/schemes/:id/edit" element={<SchemeForm />} />
          <Route path="/users" element={<Users />} />
        </Route>
      </Route>
    </Routes>
  );
}

export default AppRoutes;